var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16C18 17.1045 17.1045 18 16 18H2C0.8955 18 0 17.1045 0 16V11.5C0 10.3955 0.3955 10 1.5 10H16.5C17.6045 10 18 10.3955 18 11.5V16Z",
    fill: "#D99E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 11.933 10.933 13.5 9 13.5C7.067 13.5 5.5 11.933 5.5 10H12.5Z",
    fill: "#662113"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H16C17.1045 18 18 17.1045 18 16H0C0 17.1045 0.8955 18 2 18Z",
    fill: "#C1694F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3581 4H10.9666V1C10.9666 0.4475 10.5186 0 9.96659 0H7.96609C7.41409 0 6.96659 0.448 6.96659 1V4H4.57409C3.96259 4 3.81609 4.3115 4.24859 4.7445L8.18009 8.676C8.61259 9.1085 9.32009 9.1085 9.75309 8.676L13.6846 4.7445C14.1161 4.3115 13.9701 4 13.3581 4Z",
    fill: "#77B255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.428cf7b873d87817cd10bd76c80b1a72.svg";
export { ForwardRef as ReactComponent };